import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles.css';

// The SPA mounts into the Hugo-rendered <div id="booking-root"> in
// layouts/book/list.html. If the bundle ever loads on a page without that mount
// point, exit silently — the page is responsible for its own content then.
const rootEl = document.getElementById('booking-root');
if (rootEl) {
  createRoot(rootEl).render(
    <StrictMode>
      <BrowserRouter basename="/book">
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
}
